import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import animation from "../../../../Animation/media buying (1).json";
import { useGSAP } from "@gsap/react";
import Lottie from "react-lottie";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const ProductionTab = () => {
  const {t , i18n} = useTranslation()
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  gsap.registerPlugin(ScrollTrigger);
  useGSAP(() => {
  
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });
  return (
    <div className="WebDevelopment">
      <div className="svg">
        <div className="flex flex-col items-start">
          <h4>{t("BESPOKE SOLUTION")}</h4>
          <h5>{t("Media production")}</h5>
          <div ref={lottieContainerRef} className="w-[80vw] md:w-[35vw] mt-[5vh]">
          {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
          </div>
        </div>
      </div>
      <div className="content">
        <p>
          {t("At Sunmed isn’t just about producing content it’s about building full-scale, branded experiences that move, sell and leave a mark. We don’t just show up with a camera—we bring creative direction, detailed planning, and execution that reflects your identity. Whether you're launching a campaign, producing a podcast, or documenting a live moment, we handle every format with clarity, strategy, and high-end production value that elevates your presence across platforms.")}
        </p>
        <ul>
          <li>
          {t("Video and social ads designed to capture attention and drive real engagement.")}
          </li>
          <li>
          {t("Full podcast production from scripting and recording to editing and distribution.")}
          </li>
          <li>
          {t("In-studio or on-location shoots, with full crew, lighting, and sound setup")}
          </li>
          <li>
          {t("Product and lifestyle photography that’s tailored for both brand and performance.")}
          </li>
          <li>
          {t("Aerial and underwater filming for cinematic, perspective-shifting visuals.")}
          </li>
          <li>
          {t("Live event coverage with multi-camera setups and real-time editing delivery.")}
          </li>
        </ul>
        <Link className="btn-hover" to="media-production">
          <span>{t("Media Production")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11 4H9v18h2zm8 3h-2v12h2zM7 8.8H5v8h2zm6 .2h2v8h-2zm8 1.8h2v4h-2zm-18 0H1v4h2z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ProductionTab;
